import { Box, Button } from "@chakra-ui/react"
import { CloudArrowsFillIcon } from "@pathwright/pathicons"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import { useSyncCard } from "./SyncCardProvider"
import { SYNC_DIR_BACKWARD } from "./constants"
import { getSyncableChangesCount } from "./utils"

type PublishButtonProps = {
  disabled?: boolean
}

const PublishButton = (props: PublishButtonProps) => {
  const { disabled } = props
  const {
    syncDir,
    onPublish,
    loading,
    isPublishing,
    cohortName,
    isSourcePath,
    syncPlan
  } = useSyncCard()
  const { tc, t } = useTranslate()

  const changeCount = getSyncableChangesCount(syncPlan)

  const buttonIsLoading = loading || isPublishing
  const buttonIsDisabled = disabled || changeCount === 0

  const renderButtonLabel = () => {
    // Syncing back to source path
    return syncDir === SYNC_DIR_BACKWARD ? (
      <>
        {tc("Sync {{changeCount}} {{change}} with", {
          changeCount,
          change: changeCount === 1 ? t("change") : t("changes")
        })}{" "}
        <Box as="strong" display="inline-block" ml={1}>
          {tc("Source Path")}
        </Box>
      </>
    ) : (
      // Publishing to cohort(s)
      <>
        {" "}
        {tc("Publish {{changeCount}} {{change}} to", {
          changeCount,
          change: changeCount === 1 ? tc("change") : tc("changes")
        })}
        {isSourcePath ? (
          <>
            <Box as="strong" display="inline-block" ml={1}>
              {tc("All Cohorts")}
            </Box>
          </>
        ) : (
          <>
            <Box as="strong" display="inline-block" mx={1}>
              {cohortName}
            </Box>{" "}
            {tc("cohort.label")}
          </>
        )}
      </>
    )
  }

  return (
    <Button
      display="block" // necessary for text-overflow: ellipsis
      isDisabled={buttonIsDisabled}
      isLoading={buttonIsLoading}
      colorScheme="brand"
      cursor="pointer"
      fontWeight="400"
      onClick={disabled ? undefined : (e) => onPublish()}
      fontSize="18px"
      maxWidth={["240px", "350px"]}
      overflow="hidden"
      textOverflow={buttonIsLoading ? undefined : "ellipsis"}
      whiteSpace="nowrap"
      textAlign="center"
      sx={{
        ".chakra-button__icon": {
          marginRight: "4px",
          display: "inline-block"
        },
        svg: {
          marginBottom: "-7px"
        },
        ".chakra-button__spinner": {
          left: "calc(50% - 9px)"
        },
        strong: {
          display: "inline"
        }
      }}
      leftIcon={
        syncDir === SYNC_DIR_BACKWARD ? (
          <CloudArrowsFillIcon color="white" size="1.2em" />
        ) : undefined
      }
    >
      {renderButtonLabel()}
    </Button>
  )
}

export default PublishButton
